<template>
  <div>
    <profile-card title="Business Info">
      <form v-on:submit.prevent="submit">
        <v-field title="Logo" :error="error('logo')">
          <img :src="logo" class="tw-w-36 tw-h-36 tw-rounded tw-object-cover" />
          <div class="tw-flex tw-mt-4 tw-items-center tw-space-x-4">
            <button
              type="button"
              v-on:click.prevent="$refs.logo.click()"
              class="
                tw-rounded
                tw-bg-light
                tw-border
                tw-shadow
                tw-py-3
                tw-px-6
                tw-font-bold
                cursor:tw-border-blue cursor:tw-text-blue
              "
            >
              Change Photo
            </button>
            <button
              type="button"
              v-on:click.prevent="removeLogo"
              class="
                tw-rounded
                tw-bg-light
                tw-border
                tw-shadow
                tw-py-3
                tw-px-6
                tw-font-bold
                cursor:tw-border-red cursor:tw-text-red
              "
            >
              Remove Photo
            </button>
          </div>
          <input
            v-on:change="setLogo"
            type="file"
            class="tw-hidden"
            ref="logo"
          />
        </v-field>

        <v-field title="Cover" :error="error('cover')">
          <img
            :src="cover"
            class="tw-w-full tw-h-64 tw-rounded tw-object-cover"
          />
          <div class="tw-flex tw-mt-4 tw-items-center tw-space-x-4">
            <button
              type="button"
              v-on:click.prevent="$refs.cover.click()"
              class="
                tw-rounded
                tw-bg-light
                tw-border
                tw-shadow
                tw-py-3
                tw-px-6
                tw-font-bold
                cursor:tw-border-blue cursor:tw-text-blue
              "
            >
              Change Photo
            </button>
            <button
              type="button"
              v-on:click.prevent="removeCover"
              class="
                tw-rounded
                tw-bg-light
                tw-border
                tw-shadow
                tw-py-3
                tw-px-6
                tw-font-bold
                cursor:tw-border-red cursor:tw-text-red
              "
            >
              Remove Photo
            </button>
          </div>
          <input
            v-on:change="setCover"
            type="file"
            class="tw-hidden"
            ref="cover"
          />
        </v-field>

        <div class="form-group" style="padding: 20px 10px 5px 20px">
          <label for="have_abn">
            <input
              type="checkbox"
              v-model="form.have_abn"
              id="have_abn"
              style="width: unset; diplay: inline-block"
            />

            <h5 style="display: inline-block; font-weight: bold">
              I Have ABN
            </h5></label
          >
        </div>

        <v-field
          title="ABN Number"
          required
          :error="error('abn')"
          v-show="form.have_abn"
        >
          <span
            id="abn_ok"
            style="color: green; display: none"
            class="fa fa-check"
          ></span>
          <span
            id="abn_nok"
            style="color: red; display: none"
            class="fa fa-times"
          ></span>
          <input
            type="text"
            class="tw-form-input"
            v-model="form.abn"
            v-on:keyup="check_abn_is_valid_and_get_company_name($event)"
          />
          <span id="abn_message"></span>
          <input type="hidden" name="abn_is_valid" v-model="form.abn_is_valid" />
        </v-field>

        <v-field title="Business Name" required :error="error('name')">
          <input type="text" id="bname" class="tw-form-input" v-model="form.name" />
        </v-field>

        <v-field title="About" :error="error('about')">
          <textarea type="text" class="tw-form-input" v-model="form.about" />
        </v-field>

        <v-field title="Phone Number" required :error="error('phone_number')">
          <v-tel
            type="text"
            class="tw-form-input"
            v-model="form.phone_number"
            :enabledCountryCode="false"
            :dynamicPlaceholder="true"
            :inputOptions="{ showDialCode: true }"
          />
        </v-field>

        <v-field title="Website" :error="error('website')">
          <input type="text" class="tw-form-input" v-model="form.website" />
        </v-field>
        <!--<v-link-preview :url="form.website"></v-link-preview>-->

        <v-field title="Category" required :error="error('category_id')">
          <v-multi-select
            class="tw-relative tw--top-2px tw-p-1"
            v-model="category"
            :options="categories"
            label="label"
            track-by="title"
            placeholder="Select A Category"
            :clearOnSelect="false"
            :closeOnSelect="true"
            :preserveSearch="true"
            :searchable="true"
            :loading="categoryLoading"
            @search-change="searchCategory"
          />
        </v-field>

        <v-field title="Suburb" required :error="error('suburb_id')">
          <v-multi-select
            class="tw-relative tw--top-2px tw-p-1"
            v-model="suburb"
            :options="suburbs"
            label="label"
            track-by="title"
            placeholder="Select A Suburb"
            :clearOnSelect="false"
            :closeOnSelect="true"
            :preserveSearch="true"
            :searchable="true"
            :loading="suburbLoading"
            @search-change="searchSuburb"
          />
        </v-field>

        <button
          class="
            tw-rounded
            tw-bg-secondary
            tw-px-6
            tw-py-3
            tw-font-bold
            tw-text-2xl
            tw-text-light
            tw-mx-8
            tw-my-5
          "
        >
          Save
        </button>
      </form>
    </profile-card>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    user: {},
    profile: {},
    check_abn_is_active: {
      type: String,
      default: "0",
    },
    guid: {
      type: String,
      default: null,
    },
  },
  data: (v) => ({
    cover: v.profile.original_cover,
    logo: v.profile.original_logo,
    categories: [],
    suburbs: [],
    categoryLoading: true,
    suburbLoading: true,
    form: {
      cover: null,
      reset_cover: 0,
      logo: null,
      reset_logo: 0,
      name: v.profile.name,
      abn: v.profile.abn,
      have_abn: v.profile.abn ? true : false,
      category_id: v.profile.category_id,
      suburb_id: v.profile.suburb_id,
      phone_number: v.profile.phone_number,
      website: v.profile.website,
      about: v.profile.about,
      abn_is_valid:v.profile.abn ? 1 : 0
    },
    errors: {},
  }),
  computed: {
    category: {
      get() {
        return _.find(
          this.categories,
          (item) => item.id === this.form.category_id
        );
      },
      set(category) {
        this.form.category_id = category.id;
      },
    },
    suburb: {
      get() {
        return _.find(this.suburbs, (item) => item.id === this.form.suburb_id);
      },
      set(suburb) {
        this.form.suburb_id = suburb.id;
      },
    },
  },
  created() {
    this.searchCategory();
    this.searchSuburb();
  },
  methods: {
    searchCategory(query) {
      let self = this;
      self.categoryLoading = true;
      axios
        .get(`/api/v1/search/category/${self.form.category_id}`, {
          params: { query },
        })
        .then((resp) => {
          self.categoryLoading = false;
          self.categories = resp.data.data;
        })
        .catch((err) => {
          self.categoryLoading = false;
        });
    },
    searchSuburb(query) {
      let self = this;
      self.suburbLoading = true;
      axios
        .get(`/api/v1/search/suburb`, {
          params: { query },
        })
        .then((resp) => {
          self.suburbLoading = false;
          self.suburbs = resp.data.data;
        })
        .catch((err) => {
          self.suburbLoading = false;
        });
    },
    error(key) {
      return _.get(this.errors, `${key}.0`, false);
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    setCover(event) {
      let file = event.target.files[0];
      this.toBase64(file).then((url) => (this.cover = url));
      this.form.cover = file;
    },
    setLogo(event) {
      let file = event.target.files[0];
      this.toBase64(file).then((url) => (this.logo = url));
      this.form.logo = file;
    },
    removeLogo() {
      this.logo = this.profile.default_logo;
      this.form.logo = null;
      this.form.reset_logo = 1;
    },
    removeCover() {
      this.cover = this.profile.default_cover;
      this.form.cover = null;
      this.form.reset_cover = 1;
    },
    submit() {
      let formData = new FormData();
      _.forEach(this.form, (value, key) => {
        if (value !== null) {
          formData.append(key, value);
        }
      });

      axios({
        method: "post",
        url: `/api/v1/profile/trader-profile?api_token=${this.user.api_token}`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((resp) => {
          Vue.$toast.success(resp.data.message);
          this.errors = {};
          location.reload();
        })
        .catch((err) => {
          if (err.response && err.response.status === 422) {
            this.errors = err.response.data.errors;
          }
        });
    },

    check_abn_is_valid_and_get_company_name(event) {
      let self = this;
      let guid = self.guid;
      const abn_value = event.target.value;
      const check_abn_settgin_is_active = self.check_abn_is_active;
      if (check_abn_settgin_is_active == 1) {
        if (abn_value.length === 11) {
          $("input[name='abn']").removeClass("is-invalid");
          // 74172177893
          let url = `https://abr.business.gov.au/json/AbnDetails.aspx?abn=${abn_value}&callback=callback&guid=${guid}`;

          let xhr = new XMLHttpRequest();
          xhr.open("GET", url);

          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              let data = xhr.responseText
                .replace("callback({", "{")
                .replace("})", "}");
              let obj = JSON.parse(data);
              console.log(obj);
              let business_names = obj.EntityName;
              if (business_names.length > 0) {
                self.form.name = business_names;
                $("#bname").prop("disabled", true);
                $("#abn_message").text("ABN is valid").css("color", "green");
                $("input[name='abn']").addClass("is-valid");
                $("#abn_ok").show();
                $("#abn_nok").hide();
                self.form.abn_is_valid = 1;
              } else {
                $("input[name='abn']").addClass("is-invalid");
                $("#bname").prop("disabled", false);
                $("#abn_message").text("ABN is not valid").css("color", "red");
                $("#abn_ok").hide();
                $("#abn_nok").show();
                self.form.abn_is_valid = 0;
              }
            }
          };

          xhr.send();
        } else {
          $("input[name='abn']").addClass("is-invalid");
          $("#bname").prop("disabled", false);
          $("#abn_message").text("ABN is not valid").css("color", "red");
          $("#abn_ok").hide();
          $("#abn_nok").show();
          self.form.abn_is_valid = 0;
        }
      }
    },
  },
};
</script>
